import { Card, Col, Divider, Row, Select, DatePicker, Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react'
import { CLICK_RATE_TREND } from "../apis/apis";
import { CartesianGrid, Legend, Line, LineChart, BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip as RechartsTooltip, } from 'recharts';
const { RangePicker } = DatePicker;


function DashboardChart() {


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [trendData, setTrendData] = useState([]);
    const [trendRange, setTrendRange] = useState("7_days");
    const [customRange, setCustomRange] = useState([]);
    const [tempRange, setTempRange] = useState([]);
    const [chartType, setChartType] = useState("line");



    const getTrendData = async (
        filter_type,
        start_date = "",
        end_date = ""
    ) => {
        try {
            const formData = new FormData();

            formData.append("filter_type", filter_type);

            if (start_date) {
                formData.append("start_date", start_date);
            }

            if (end_date) {
                formData.append("end_date", end_date);
            }

            const response = await CLICK_RATE_TREND(formData);

            if (response?.status === 200) {
                setTrendData(response?.data?.trend || []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getTrendData("7_days");
    }, []);


    const handleApply = () => {
        setCustomRange(tempRange);
        setTrendRange("custom");
        setIsModalOpen(false);

        const payload = {
            filter_type: "custom",
            from_date: tempRange?.[0]?.format("YYYY-MM-DD"),
            to_date: tempRange?.[1]?.format("YYYY-MM-DD"),
        };

        console.log(payload);
    };

    const handleTrendChange = (value) => {
        setTrendRange(value);

        if (value === "7_days") {
            getTrendData("7_days");
        }

        if (value === "30_days") {
            getTrendData("30_days");
        }

        if (value === "3_months") {
            getTrendData("3_months");
            return;
        }

        setTrendRange(value);
        getTrendData(value);
    };

    const handleCancel = () => {
        setTempRange(customRange);
        setIsModalOpen(false);
    };

    return (
        <div >

            <Row style={{ marginTop: "20px" }}>
                <Col span={24}>
                    <Card
                        title={<h3>Performance Trend Over Time</h3>}

                        extra={
                            <div style={{ display: "flex", gap: "10px" }}>
                                <Select
                                    value={trendRange}
                                    onChange={handleTrendChange}
                                    style={{ width: 180 }}
                                    options={[
                                        {
                                            label: "Last 7 Days",
                                            value: "7_days",
                                        },
                                        {
                                            label: "Last 30 Days",
                                            value: "30_days",
                                        },
                                        {
                                            label: "Last 3 Months",
                                            value: "3_months",
                                        },

                                    ]}
                                />

                                <Select
                                    value={chartType}
                                    onChange={(value) => setChartType(value)}
                                    style={{ width: 120 }}
                                    options={[
                                        {
                                            label: "Line",
                                            value: "line",
                                        },
                                        {
                                            label: "Bar",
                                            value: "bar",
                                        },
                                    ]}
                                />
                            </div>
                        }
                    >
                        <p
                            style={{
                                color: "#888",
                                marginBottom: "20px",
                            }}
                        >
                            Compare key metrics over the selected time period
                        </p>


                        <ResponsiveContainer width="100%" height={400}>
                            {chartType === "line" ? (
                                <LineChart
                                    data={trendData}
                                    margin={{
                                        top: 20,
                                        right: 20,
                                        left: 40,
                                        bottom: 30,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />

                                    <XAxis
                                        dataKey="label"
                                        angle={-20}
                                        textAnchor="end"
                                        height={80}
                                        interval={0}
                                        padding={{ left: 20, right: 20 }}
                                    />

                                    <YAxis
                                        domain={[0, 100]}
                                        ticks={[0, 25, 50, 75, 100]}
                                        tickFormatter={(value) => `${value}%`}
                                    />

                                    <RechartsTooltip />
                                    <Legend />

                                    <Line
                                        type="monotone"
                                        dataKey="sent_rate"
                                        name="Sent Rate"
                                        stroke="#8c3add"

                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="open_rate"
                                        name="Open Rate"
                                        stroke="#1fa7a1"
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="click_rate"
                                        name="Click Rate"
                                        stroke="#eab451"
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="submit_rate"
                                        name="Submit Rate"
                                        stroke="#b37feb"
                                    />

                                    <Line
                                        type="monotone"
                                        dataKey="report_rate"
                                        name="Report Rate"
                                        stroke="#5B8DEF"
                                    />
                                </LineChart>
                            ) : (
                                <BarChart
                                    data={trendData}
                                    margin={{
                                        top: 20,
                                        right: 20,
                                        left: 40,
                                        bottom: 30,
                                    }}
                                >                                    <CartesianGrid strokeDasharray="3 3" />

                                    <XAxis
                                        dataKey="label"
                                        angle={-20}
                                        textAnchor="end"
                                        height={80}
                                        interval={0}
                                        padding={{ left: 20, right: 20 }}
                                    />

                                    <YAxis
                                        domain={[0, 100]}
                                        ticks={[0, 25, 50, 75, 100]}
                                        tickFormatter={(value) => `${value}%`}
                                    />

                                    <RechartsTooltip />
                                    <Legend />

                                    <Bar
                                        dataKey="sent_rate"
                                        name="Sent Rate"
                                        fill="#8c3add"
                                    />

                                    <Bar
                                        dataKey="open_rate"
                                        name="Open Rate"
                                        fill="#1fa7a1"
                                    />

                                    <Bar
                                        dataKey="click_rate"
                                        name="Click Rate"
                                        fill="#eab451"
                                    />

                                    <Bar
                                        dataKey="submit_rate"
                                        name="Submit Rate"
                                        fill="#b37feb"
                                    />

                                    <Bar
                                        dataKey="report_rate"
                                        name="Report Rate"
                                        fill="#5B8DEF"
                                    />
                                </BarChart>
                            )}
                        </ResponsiveContainer>


                    </Card>
                </Col>
            </Row>



        </div>
    )
}

export default DashboardChart
